import React from 'react';
import PropTypes from 'prop-types';
import Slider from '../Slider/Slider';
import ManagementWarning from '../ManagementWarning';
import ManageMachineTypesTab from './ManageMachineTypesTab';
import { useDocumentTitle } from '../../../utils/useDocumentTitle';

function MachineTypesWarningTab({ user, labId, pushTab, revert, index }) {
  useDocumentTitle('Admin: Before managing tools – Pinpoint');
  return <Slider name="Before managing tools" slide index={index} onClick={() => revert(1)}>
    <ManagementWarning title="Review tool access before making changes" onCancel={() => revert(1)}
      onContinue={() => pushTab(<ManageMachineTypesTab adminRoute="tools" key={`ManageMachineTypesTab-${labId}`}
        user={user} labId={labId} pushTab={pushTab} revert={revert} />)}>
      Tools are shared across spaces. Before adding a tool, review how people will gain access to its instances. Access depends on space settings, badge requirements and any applicable overrides.
    </ManagementWarning>
  </Slider>;
}

MachineTypesWarningTab.propTypes = {
  user: PropTypes.object.isRequired,
  labId: PropTypes.string.isRequired,
  pushTab: PropTypes.func.isRequired,
  revert: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};
export default MachineTypesWarningTab;
